import { template as template_67fdf27d9f1840e09eef6f96dcec2f6b } from "@ember/template-compiler";
import { isPresent } from '@ember/utils';
const getOptionsWithDefault = (options, displayedField, defaultOption)=>{
    if (isPresent(defaultOption)) {
        return [
            {
                isDefaultOption: true,
                [displayedField]: defaultOption
            },
            ...options
        ];
    }
    return options;
};
const getSelectedOption = (selected, optionsWithDefault)=>{
    if (selected == null) {
        return optionsWithDefault[0];
    } else {
        return selected;
    }
};
export default template_67fdf27d9f1840e09eef6f96dcec2f6b(`
{{#let (getOptionsWithDefault @options @displayedField @defaultOption) as |optionsWithDefault|}}
  {{yield
    optionsWithDefault
    (getSelectedOption @selected optionsWithDefault)
  }}
{{/let}}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
